<template>
  <div class="container">
    <img
      class="map-bg"
      src="../../assets/icon/map1.png"
      alt=""
    />
    <div>
      <div
        class="sign1"
        @mouseenter="changeStyle('sign1', true)"
        @mouseleave="changeStyle('sign1', false)"
      >
        <div class="sign1-1"></div>
      </div>
      <div
        class="sign2"
        @mouseenter="changeStyle('sign2', true)"
        @mouseleave="changeStyle('sign2', false)"
      >
        <div class="sign2-1"></div>
      </div>
      <div
        class="sign3"
        @mouseenter="changeStyle('sign3', true)"
        @mouseleave="changeStyle('sign3', false)"
      >
        <div class="sign3-1"></div>
      </div>
      <div
        class="sign4"
        @mouseenter="changeStyle('sign4', true)"
        @mouseleave="changeStyle('sign4', false)"
      >
        <div class="sign4-1"></div>
      </div>
      <div
        class="sign5"
        @mouseenter="changeStyle('sign5', true)"
        @mouseleave="changeStyle('sign5', false)"
      >
        <div class="sign5-1"></div>
      </div>
    </div>
    <div>
      <div
        :class="
          hover_sign === 'sign1'
            ? 'suspension-box suspension-box1 hover-now'
            : 'suspension-box suspension-box1'
        "
      >
        <div class="flex-ct">
          <img class="icon" src="../../assets/icon/map-car.png" alt="" />
          <div class="font1">50分钟</div>
        </div>
        <div class="font2">距离苏州工业园区40公里</div>
      </div>
      <div
        :class="
          hover_sign === 'sign2'
            ? 'suspension-box suspension-box2 hover-now'
            : 'suspension-box suspension-box2'
        "
      >
        <div class="flex-ct">
          <img class="icon" src="../../assets/icon/map-car.png" alt="" />
          <div class="font1">50分钟</div>
        </div>
        <div class="font2">距离昆山小核酸产业基地28公里</div>
      </div>
      <div
        :class="
          hover_sign === 'sign3'
            ? 'suspension-box suspension-box3 hover-now'
            : 'suspension-box suspension-box3'
        "
      >
        <div class="flex-ct">
          <img class="icon" src="../../assets/icon/map-car.png" alt="" />
          <div class="font1">30分钟</div>
        </div>
        <div class="font2">距离昆山市人民政府26公里</div>
      </div>
      <div
        :class="
          hover_sign === 'sign4'
            ? 'suspension-box suspension-box4 hover-now'
            : 'suspension-box suspension-box4'
        "
      >
        <div class="flex-ct">
          <img class="icon" src="../../assets/icon/map-car.png" alt="" />
          <div class="font1">30分钟</div>
        </div>
        <div class="font2">距离虹桥国际机场37公里</div>
      </div>
      <div
        :class="
          hover_sign === 'sign5'
            ? 'suspension-box suspension-box5 hover-now'
            : 'suspension-box suspension-box5'
        "
      >
        <div class="flex-ct">
          <img class="icon" src="../../assets/icon/map-car.png" alt="" />
          <div class="font1">25分钟</div>
        </div>
        <div class="font2">距离华为研发中心21公里</div>
      </div>

      <div class="suspension-box suspension-box6">
        <div class="flex-ct">
          <img class="icon" src="../../assets/icon/map-icon1.png" alt="" />
          <div class="font1">10分钟</div>
        </div>
        <div class="font2">距离附近任意高速</div>
      </div>
      <div class="suspension-box suspension-box7">
        <div class="flex-ct">
          <img class="icon" src="../../assets/icon/map-icon2.png" alt="" />
          <div class="font1">长三角C位</div>
        </div>
        <div class="font2">长三角区域核心位置</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";

const hover_sign = ref<string | null>(null);
const is_move = ref(window.innerWidth < 600);
function changeStyle(sign: string, isHovered: boolean) {
  if (is_move.value) {
    return;
  }
  hover_sign.value = isHovered ? sign : null;
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100vw;
  height: calc(100vw * 1000 / 2400);
  overflow: hidden;
}
/* 当屏幕宽度小于或等于 600px 时 */
@media (max-width: 600px) {
  .container {
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
}
.map-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
@media (max-width: 600px) {
  .map-bg {
    object-fit: cover; /* 保持图片比例，裁剪多余部分 */
    object-position: 45% 50%; /* 图片中心对齐 */
  }
}
.font1 {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 600;
  line-height: 19.6px;
  color: #000000;
}
.font2 {
  font-family: PingFang SC;
  font-size: 14px;
  line-height: 19.6px;
  color: #272724;
}
.sign1 {
  position: absolute;
  top: calc(100vw * 1000 / 2400 * 0.135);
  left: 37vw;
  width: 0.3vw;
  height: calc(100vw * 1000 / 2400 * 0.44);
  transform: rotate(-85.5deg);
}
.sign1-1 {
  content: "";
  position: absolute;
  top: calc(100vw * 1000 / 2400 * 0.22);
  left: -0.35vw;
  width: 1.3vw;
  height: calc(100vw * 1000 / 2400 * 0.09);
}

.sign2 {
  position: absolute;
  top: calc(100vw * 1000 / 2400 * 0.135);
  left: 45vw;
  width: 0.3vw;
  height: calc(100vw * 1000 / 2400 * 0.22);
  transform: rotate(-27deg);
}
.sign2-1 {
  content: "";
  position: absolute;
  top: calc(100vw * 1000 / 2400 * 0.13);
  left: -1.7vw;
  width: 3.7vw;
  height: calc(100vw * 1000 / 2400 * 0.03);
  transform: rotate(24deg);
}

.sign3 {
  position: absolute;
  top: calc(100vw * 1000 / 2400 * 0.13);
  left: 50.6vw;
  width: 0.3vw;
  height: calc(100vw * 1000 / 2400 * 0.24);
  transform: rotate(29deg);
}
.sign3-1 {
  content: "";
  position: absolute;
  top: calc(100vw * 1000 / 2400 * 0.09);
  left: -1.7vw;
  width: 3.7vw;
  height: calc(100vw * 1000 / 2400 * 0.03);
  transform: rotate(-23deg);
}

.sign4 {
  position: absolute;
  top: calc(100vw * 1000 / 2400 * 0.22);
  left: 55.8vw;
  width: 0.3vw;
  height: calc(100vw * 1000 / 2400 * 0.33);
  transform: rotate(91.5deg);
}
.sign4-1 {
  content: "";
  position: absolute;
  top: calc(100vw * 1000 / 2400 * 0.15);
  left: -1.9vw;
  width: 3.7vw;
  height: calc(100vw * 1000 / 2400 * 0.03);
  transform: rotate(-94deg);
}

.sign5 {
  position: absolute;
  top: calc(100vw * 1000 / 2400 * 0.42);
  left: 46.8vw;
  width: 0.3vw;
  height: calc(100vw * 1000 / 2400 * 0.22);
  transform: rotate(185.5deg);
}
.sign5-1 {
  content: "";
  position: absolute;
  top: calc(100vw * 1000 / 2400 * 0.074);
  left: -1.85vw;
  width: 3.7vw;
  height: calc(100vw * 1000 / 2400 * 0.03);
  transform: rotate(-185.5deg);
}

.suspension-box {
  position: absolute;
  width: 220px;
  padding: 16px 0;
  background: #fff;
  text-align: center;
  transition: all 0.3s ease;
  border-radius: 4px;

  .icon {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
}

.hover-now {
  background: #fcb353;
  width: 300px;
}

.suspension-box1 {
  top: calc((100vw * 1000 / 2400 - 80px * 3) / 4 * 2 + 80px);
  left: 0;
}
.suspension-box2 {
  top: calc((100vw * 1000 / 2400 - 80px * 3) / 4);
  left: 0;
}
.suspension-box3 {
  top: calc((100vw * 1000 / 2400 - 80px * 2) / 3);
  right: 0;
}
.suspension-box4 {
  top: calc((100vw * 1000 / 2400 - 80px * 2) / 3 * 2 + 80px);
  right: 0;
}
.suspension-box5 {
  top: calc((100vw * 1000 / 2400 - 80px * 3) / 4 * 3 + 80px * 2);
  left: 0;
}
.suspension-box6 {
  left: calc(50vw - 230px);
  bottom: 20px;
}
.suspension-box7 {
  right: calc(50vw - 230px);
  bottom: 20px;
}
@media (max-width: 600px) {
  .suspension-box1 {
    top: calc((100vh - 80px * 7) / 6 + 90px);
    left: 40px;
    width: calc(100vw - 80px);
  }
  .suspension-box2 {
    top: calc((100vh - 80px * 7) / 6);
    left: 40px;
    width: calc(100vw - 80px);
  }
  .suspension-box3 {
    top: calc((100vh - 80px * 7) / 6 + 90px * 2);
    left: 40px;
    width: calc(100vw - 80px);
  }
  .suspension-box4 {
    top: calc((100vh - 80px * 7) / 6 + 90px * 3);
    left: 40px;
    width: calc(100vw - 80px);
  }
  .suspension-box5 {
    top: calc((100vh - 80px * 7) / 6 + 90px * 4);
    left: 40px;
    width: calc(100vw - 80px);
  }
  .suspension-box6 {
    top: calc((100vh - 80px * 7) / 6 + 90px * 5);
    left: 40px;
    height: 40px;
    width: calc(100vw - 80px);
  }
  .suspension-box7 {
    top: calc((100vh - 80px * 7) / 6 + 90px * 6);
    left: 40px;
    width: calc(100vw - 80px);
    height: 40px;
  }
}
</style>
